<template>
	<section v-if="items.length" class="mosaic-wrapper">
		<div class="mosaic-row">
			<div v-for="row in items" :key="row.position" :class="`layout-${row.layout}`" class="mosaic-section">
				<div
					v-for="(tessera, idx) in row.tessera"
					:key="idx"
					:class="[{ 'mosaic-text-content': !tessera.image }, tessera.color]"
					class="mosaic-content"
				>
					<picture v-if="tessera.image">
						<source :srcset="tessera.imageWebp" type="image/webp" />
						<source :srcset="tessera.image" />
						<img class="mosaic-img" :src="tessera.image" loading="lazy" :alt="tessera.imageAlt" />
					</picture>
					<span v-else v-parse-links v-html="tessera.content" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.mosaic-wrapper {
	width: 100%;
	padding: 75px 0.5vw 0;
	background: var(--secondary-background-color);

	.mosaic-row {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 15px;

		.mosaic-section {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(2, 25vw);
			gap: 15px;

			.mosaic-content {
				padding: 0;
				text-align: center;
				background: var(--primary-background-color);
				box-shadow: 0 0 10px rgb(0 0 0 / 5%);

				.button.no-fill,
				:deep(.button.no-fill) {
					border-color: #fff;
					color: #fff;

					&:hover {
						background: #fff;
						color: var(--cta-color-hover);
					}
				}

				&.green {
					background: #033;
					color: #fff;

					:deep(h2),
					:deep(h3),
					:deep(h4) {
						color: #fff;
					}
				}

				&.blue {
					background: #003;
					color: #fff;

					:deep(h2),
					:deep(h3),
					:deep(h4) {
						color: #fff;
					}
				}

				:deep(h2),
				:deep(h3),
				:deep(h4) {
					font-size: 1.6em;
				}

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
				}
			}

			.mosaic-text-content {
				padding: 5px 25px;
				display: flex;
				align-items: center;
			}
		}
	}
}

.layout-2 .mosaic-content:nth-child(1),
.layout-4 .mosaic-content,
.layout-5 .mosaic-content:nth-child(2) {
	grid-row: span 2;
}

.layout-3 .mosaic-content:nth-child(1),
.layout-6 .mosaic-content:nth-child(3),
.layout-7 .mosaic-content {
	grid-column: span 2;
}

.layout-8 .mosaic-content {
	grid-area: span 2 / span 2;
}

@media (max-width: 1280px) {
	.mosaic-wrapper .mosaic-row .mosaic-section .mosaic-text-content {
		padding: 25px;
	}
}

@media (max-width: 1180px) {
	.mosaic-wrapper .mosaic-row {
		grid-template-columns: 1fr;

		.mosaic-section {
			grid-template-rows: repeat(2, 50vw);
		}
	}
}

@media (max-width: 580px) {
	.mosaic-wrapper .mosaic-row .mosaic-section {
		grid-template-columns: 1fr;
		grid-template-rows: auto;
	}

	.layout-2 .mosaic-content:nth-child(1),
	.layout-3 .mosaic-content:nth-child(1),
	.layout-4 .mosaic-content,
	.layout-5 .mosaic-content:nth-child(2),
	.layout-6 .mosaic-content:nth-child(3),
	.layout-7 .mosaic-content,
	.layout-8 .mosaic-content {
		grid-area: auto / auto;
	}

	.mosaic-wrapper .mosaic-row .mosaic-section .mosaic-text-content {
		padding: 50px 25px;
	}

	.mosaic-content {
		min-height: 75vw;
	}
}
</style>
